import { baseApi } from "@/config/http-common";

class LayoutDataService {
  get(): Promise<any> {
    return baseApi.get(`/common/layout`);
  }
}

export default new LayoutDataService();
